import type { FormChatState } from "../repositories/formChat.repository";
import type {
  AddSpiritualProfileEntityPayload,
  SpiritualDevelopmentStage,
  SpiritualVisibility,
} from "../repositories/spiritualProfileRepository";

const DEVELOPMENT_STAGES: SpiritualDevelopmentStage[] = [
  "initial_contact",
  "developing",
  "confirmed",
  "active_work",
];

const VISIBILITIES: SpiritualVisibility[] = ["only_me", "leaders", "terreiro"];

const isDevelopmentStage = (
  value: unknown,
): value is SpiritualDevelopmentStage =>
  typeof value === "string" &&
  DEVELOPMENT_STAGES.includes(value as SpiritualDevelopmentStage);

const isVisibility = (value: unknown): value is SpiritualVisibility =>
  typeof value === "string" &&
  VISIBILITIES.includes(value as SpiritualVisibility);

export const buildSpiritualProfileFormChatPayload = (
  data: FormChatState,
): Omit<AddSpiritualProfileEntityPayload, "terreiroId" | "mediumId"> | null => {
  if (!isDevelopmentStage(data.developmentStage) || !isVisibility(data.visibility)) {
    return null;
  }

  const notes =
    typeof data.notes === "string" && data.notes.trim()
      ? data.notes.trim()
      : undefined;

  if (data.entryMode === "line" || (!data.entityId && !data.entityName)) {
    if (!data.lineId) return null;
    return {
      lineId: data.lineId,
      developmentStage: data.developmentStage,
      visibility: data.visibility,
      notes,
    };
  }

  if (data.entityId) {
    return {
      entityId: data.entityId,
      developmentStage: data.developmentStage,
      visibility: data.visibility,
      notes,
    };
  }

  if (data.entityName && data.lineId) {
    return {
      lineId: data.lineId,
      entityName: data.entityName,
      developmentStage: data.developmentStage,
      visibility: data.visibility,
      notes,
    };
  }

  return null;
};
